import { FC } from 'react'
import { IconButton } from '@cargomart/ui'
import IconArrowLeft from 'remixicon/icons/Arrows/arrow-left-line.svg?react'
import IconSearch from 'remixicon/icons/System/search-line.svg?react'

export interface OrderFilterModeToggleProps {
  isLargeLaptop: boolean | undefined
  isSearchMode: boolean
  onToggle: () => void
}

export const OrderFilterModeToggle: FC<OrderFilterModeToggleProps> = ({ isLargeLaptop, isSearchMode, onToggle }) => (
  <div className="mr-4">
    <IconButton outline onClick={onToggle} size={isLargeLaptop ? 'lg' : 'nm'}>
      {isSearchMode ? (
        <IconArrowLeft size={isLargeLaptop ? 'nm' : 'sm'} />
      ) : (
        <IconSearch size={isLargeLaptop ? 'nm' : 'sm'} />
      )}
    </IconButton>
  </div>
)
